module.exports = __webpack_public_path__ + "media/parents/deadlines-vary-5ddd4060.png";